import React, { useState, useCallback } from "react";
import { useT } from "@transifex/react";
import { RendererProps } from "./index";
import { TextInput } from "./renderer-styles";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailInputRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const t = useT();
  const [value, setValue] = useState<string>(answer?.value ?? "");

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      setValue(val);
      const isValid = val.trim().length === 0
        ? !question.required
        : EMAIL_PATTERN.test(val);
      onAnswer(val, isValid);
    },
    [onAnswer, question.required]
  );

  return (
    <TextInput
      type="email"
      value={value}
      onChange={handleChange}
      placeholder={question.placeholder || t("email@example.com")}
    />
  );
};

export default EmailInputRenderer;
